import React from 'react';
import PropTypes from 'prop-types';

import styles from '../QuestionDisplay.scss';
import OutcomeIcon from '../interactionOutcome/OutcomeIcon';
import TextEntryPrint from '../interactions/textEntryInteraction/TextEntryPrint';
import TextEntryCorrectResponsesInfo from '../interactions/textEntryInteraction/TextEntryCorrectResponsesInfo';
import { t } from '../../../services/i18nService';
import FeedbackNavigationButton from '../../buttons/FeedbackNavigationButton';
import feedbackOutcomeSelector from '../../../selectors/feedback/FeedbackOutcomeSelector';
import TextEntryReactMathKeyboardInput from '../interactions/textEntryInteraction/TextEntryReactMathKeyboardInput';
import responseService from '../../../services/ResponseService';

const defaultState = {
    expanded: true,
};

class FeedbackForResponseOutcomeContent extends React.PureComponent {
    constructor(props, context) {
        super(props, context);
        this.state = defaultState;
    }

    toggleHeader = () => {
        this.setState({
            expanded: !this.state.expanded,
        });
    }

    getHeaderClass() {
        return `${styles.feedbackHeader} ${styles.feedbackHeaderUnChecked} ${styles.headerWithOutcome}`;
    }

    getTextEntryUserResponse() {
        const {
            userResponse,
            responseModel,
        } = this.props;

        const fakeFunction = () => {};

        const isReactMathKeyboardEnabled = responseService.isReactMathKeyboardForSymbolicMathEnabled(
            responseModel.baseType,
            responseModel.interactionType,
        );

        if (isReactMathKeyboardEnabled) {
            return (
                <TextEntryReactMathKeyboardInput
                    model={responseModel}
                    handleInteractionReady={fakeFunction}
                    defaultValue={Array.isArray(userResponse) ? userResponse[0] : ''}
                    isReadOnly
                />
            );
        }

        return (
            <TextEntryPrint
                defaultValue={Array.isArray(userResponse) ? userResponse[0] : ''}
                handleInteractionReady={fakeFunction}
                size={3}
            />
        );
    }

    render() {
        const {
            index,
            inlineFeedback,
            feedbackHeaderCaption,
            isPartiallyCorrect,
            isCorrect,
            showOutcomeIconIndicators,
            responseModel,
            isAttempted,
            correctResponsesData,
            hasValidResponseFeedback,
        } = this.props;
        const fakeFunction = () => {};

        return (
            inlineFeedback ? (<div className={`${styles.feedbackPerResponse} feedbackPerResponse text`}>
                <div id={`${this.props.question.identifier}_${this.props.identifier}_feedback`} className={this.getHeaderClass()}>
                    <button id={`feedback_label_${index}`} className={styles.toggle} aria-expanded={this.state.expanded} onClick={this.toggleHeader}>
                        <i className={`fa ${this.state.expanded ? 'fa-chevron-down' : 'fa-chevron-right'}`} aria-hidden />
                        <span className={`${styles.feedbackOn}`}>{feedbackHeaderCaption}</span>
                    </button>
                    <div className={styles.outcomeContainer}>
                        {this.getTextEntryUserResponse()}

                        {
                            showOutcomeIconIndicators && <OutcomeIcon
                                isCorrect={isCorrect}
                                isPartiallyCorrect={isPartiallyCorrect}
                                isAttempted={isAttempted}
                                onReady={fakeFunction}
                            />
                        }
                        {
                            correctResponsesData && <TextEntryCorrectResponsesInfo
                                model={responseModel}
                                outcomeIsCorrect={`${isCorrect}`}
                                correctResponses={correctResponsesData}
                            />
                        }
                        {hasValidResponseFeedback && (<FeedbackNavigationButton
                            destinationSelector={`[id="${this.props.question.identifier}_${this.props.identifier}"] .interaction`}
                            label={t('questionFeedback.navigateToQuestion')}
                            buttonType="responseOutcome"
                        />)}
                    </div>
                </div>
                {this.state.expanded ?
                    <div aria-labelledby={`feedback_label_${index}`} className={`${styles.feedbackBody}`}>
                        <React.Fragment>
                            <div
                                dangerouslySetInnerHTML={{ __html: ` ${inlineFeedback} ` }}
                                className="text"
                            />
                        </React.Fragment>
                    </div>
                    :
                    null
                }
            </div>) : null
        );
    }
}

FeedbackForResponseOutcomeContent.propTypes = {
    index: PropTypes.number,
    inlineFeedback: PropTypes.string,
    feedbackHeaderCaption: PropTypes.string,
    isPartiallyCorrect: PropTypes.bool,
    isCorrect: PropTypes.bool,
    userResponse: PropTypes.array,
    showOutcomeIconIndicators: PropTypes.bool,
    responseModel: PropTypes.object,
    isAttempted: PropTypes.bool,
    correctResponsesData: PropTypes.array,
    question: PropTypes.object,
    // identifier for interaction inside the question (RESPONSE-1,...)
    identifier: PropTypes.string,
    hasValidResponseFeedback: PropTypes.bool,
};

const FeedbackForResponseOutcome = props => (
    <FeedbackForResponseOutcomeContent {...props} {...feedbackOutcomeSelector.selectProps(props)} />
);

export default FeedbackForResponseOutcome;
